/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useState, useEffect } from 'react';
import { Box, Center, ScrollView } from 'native-base';
import routes, { AppRouteProps, useAppNavigate } from '~/pages';
import { useMenuStyles } from '~/shared/styles';
import { Logo2xl } from '~/shared/Image';
import CardMenu from './components/CardMenu';
import CardMenuAdditionalLink from './components/CardMenuAdditionalLink';
import { useSpringBigStore, useAppSettings, SideNav, BottomNav, useI18n, I18nReacher } from '@springbig/shared';
import { generatePath } from '~/utils/url';

type SideMenuScreenProps = {
    toggleMenu: () => void;
}

const SideMenuScreen = (props: SideMenuScreenProps) => {

    const { additionalStackMenuLinks, sideNav  } = useAppSettings();
    const [links, setLinks] =
        useState<Array<RouteProps | SideNav | BottomNav>>([]);
    const { member, merchant } = useSpringBigStore();
    const { params } = useAppNavigate();
    const {
        background
    } = useMenuStyles();
    const { t } = useI18n();

    useEffect(() => {

        let _items = routes;
        let _sideNav = sideNav && sideNav.length > 0 && sideNav.filter(el => el.toScreen !== 'LocationStore');

        if (merchant && member && _items && _items.length > 0) {

            _sideNav = _sideNav && _sideNav.filter(el => !el?.toUrl?.includes('enrollnow.vip'));

            if (!member.subscriptions_enabled) {
                _items = _items.filter(t => ((t as RouteProps).title || (t as BottomNav).toScreen) !== 'Subscriptions');
            }

            if (!member.gift_card_enabled) {
                _items = _items.filter(t => ((t as RouteProps).title || (t as BottomNav).toScreen) !== 'SpringbigPay');
            }

            if (!member.show_milestones) {
                _items = _items.filter(t => ((t as RouteProps).title || (t as BottomNav).toScreen) !== 'Milestones');
            }

            if (!member.show_rewards) {
                _items = _items.filter(t => ((t as RouteProps).title || (t as BottomNav).toScreen) !== 'Rewards');
            }

            if (!member.merchant_website) {
                _items = _items.filter(t => ((t as RouteProps).title || (t as BottomNav).toScreen) !== 'Cart');
            }

            if (!member.referrals?.active) {
                _items = _items.filter(t => ((t as RouteProps).title || (t as BottomNav).toScreen) !== 'Refer');
            }

            if (!merchant.dutchie_plus_enabled) {
                _items = _items.filter(t => ((t as RouteProps).title || (t as BottomNav).toScreen) !== 'Shop');
            }
        }

        const filteredSideNav = _items && _items.length > 0 && _sideNav && _sideNav.length > 0 && _sideNav.map(sideNavItem => {

            if (!sideNavItem.toUrl) {
                const match = _items.find((el) => el.title === sideNavItem.toScreen);
                if (match) {
                    return { ...match, customLabel: sideNavItem.customLabel };
                }
            }

            return sideNavItem;
        });

        setLinks(filteredSideNav);
    }, [member]);

    return (
        <Box
            flex={1}
            justifyContent='center'
            w={'100%'}
        >
            <ScrollView flex={1} bg={background}>
                <Center>
                    <Logo2xl h={120} />
                    <Box w={'100%'} mb={4}>
                        {
                            links && links.length > 0 && links.map((link, index) => {

                                const path = (link as RouteProps).path && generatePath((link as RouteProps).path, params.wallet_id!) || (link as SideNav).toUrl;
                                const title = ((link as BottomNav).customLabel || (link as RouteProps).title && t(`navigation.${(link as RouteProps).title.toLowerCase()}` as I18nReacher)) || (link as SideNav).customLabel;

                                if (!title) {
                                    return;
                                }

                                return <CardMenu
                                    path={path as AppRouteProps}
                                    title={title}
                                    testID={title}
                                    toggleMenu={props.toggleMenu}
                                    key={index}
                                />;
                            })
                        }
                        {
                            additionalStackMenuLinks && additionalStackMenuLinks.length > 0 && additionalStackMenuLinks.map((link) => (

                                <CardMenuAdditionalLink
                                    key={link.label}
                                    screen={link.screen as AppRouteProps}
                                    external={link.external}
                                    url={link.url as string}
                                    label={link.label}
                                    toggleMenu={props.toggleMenu}
                                />
                            ))
                        }
                    </Box>
                </Center>
            </ScrollView>
        </Box>
    );
};

export default SideMenuScreen;
